import { app } from '../../../../../bootstrap/core';
import { contractingPartnersComponent } from './contractingPartners.component';

app.component('contractingPartners', contractingPartnersComponent);
